import { render, staticRenderFns } from "./B_SettingShop.vue?vue&type=template&id=0ea2d651&scoped=true&"
import script from "./B_SettingShop.vue?vue&type=script&lang=js&"
export * from "./B_SettingShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea2d651",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ea2d651')) {
      api.createRecord('0ea2d651', component.options)
    } else {
      api.reload('0ea2d651', component.options)
    }
    module.hot.accept("./B_SettingShop.vue?vue&type=template&id=0ea2d651&scoped=true&", function () {
      api.rerender('0ea2d651', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/setting/B_SettingShop.vue"
export default component.exports